import { ModalWrapper } from "src/utils/fw"
import { modalColor } from "../utils"

export default {
    background: "https://assets.swoogo.com/uploads/full/4561633-6716bb38c70db.png",
    name: "on-demand",
    links: [
            {
                label: "Keynotes on Demand",
                height: "39.7%",
                left: "2.9%",
                top: "30.8%",
                width: "13.1%",
                href: "/keynotesondemand",
            },
            {
                label: "Breakouts on Demand",
                height: "38.5%",
                left: "83.3%",
                top: "31.9%",
                width: "13.7%",
                href: new Date() > new Date("2023-10-23 08:00:00+0200") ? "/breakoutondemand" : undefined,
                modal: new Date() > new Date("2023-10-23 08:00:00+0200") ? undefined : <ModalWrapper wrapperStyle={{background: modalColor}}>
			    <h1 style={{color: "white"}}>Breakout sessions will be released each day at 08:00 CEST, beginning on Monday 23 October.</h1>
		       </ModalWrapper>,
		            modalOverrides: {
			        dismissHTML: "X",
			        dismissStyle: {
				    color: "white",
				    "font-size": "20px"
			        }
		        }
            },
            {
                label: "Congress Back in Time",
                width: "8.8%",
                height: "23.1%",
                left: "77.7%",
                top: "68.1%",
                href: "https://www.isflive.org/s/congress/back-in-time",
                target: "blank"
            },
    ].map(it => {
        if (new Date() < new Date("2023-10-22 08:00:00+0200")) {
            return {
                ...it,
                href: undefined,
                modal: new Date() > new Date("2023-10-23 08:00:00+0200") ? undefined : <ModalWrapper wrapperStyle={{background: modalColor}}>
                    <h1 style={{color: "white"}}>On-Demand sessions will be released each day at 08:00 CEST, beginning on Monday 23 October.</h1>
                </ModalWrapper>,
                modalOverrides: {
                    dismissHTML: "X",
                    dismissStyle: {
                        color: "white",
                        "font-size": "20px"
                    }
                }
            }
        }
        return it
    })
}